export const getFileNameFromDisposition = (disposition) => {
  if (disposition && disposition.indexOf('attachment') !== -1) {
      console.log('disposition', disposition);
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
      console.log('matches', matches);
    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
    return '';
  }
  return '';
}
